import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MModalite, MSatisfaction } from '@argalis-apps/models';
import * as DATA_TEST from './data-test';

import { CommunicationConfigService, ConfigService } from '@argalis-apps/angular-global';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class SatisfactionFormService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private communicationConfigService: CommunicationConfigService
  ) {}

  getListDescriptionDefaultSatisfaction(): Observable<MModalite.IModalite[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of(DATA_TEST.satisfactionDefaultList);
    } else {
      return this.http.get<MModalite.IModalite[]>(
        `${this.communicationConfigService.getApiUri()}/apprenant/session/satisfaction/default/description`
      );
    }
  }

  getListDescriptionOptionalSatisfaction(id_session): Observable<MModalite.IModalite[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of(DATA_TEST.satisfactionDefaultList);
    } else {
      return this.http.get<MModalite.IModalite[]>(
        `${this.communicationConfigService.getApiUri()}/apprenant/session/${id_session}/satisfaction/optional/description`
      );
    }
  }

  getSatisfactionDefaultValue(
    id_apprenant: number,
    id_session: number
  ): Observable<MSatisfaction.ISatisfactionDefaultParms> {
    if (this.configService.getOptions().useTestData === true) {
      const TEST_EMPTY_LIST = false;
      if (TEST_EMPTY_LIST) {
        return of({} as MSatisfaction.ISatisfactionDefaultParms);
      } else {
        return of(DATA_TEST.satisfactionDefaulValue);
      }
    } else {
      return this.http.get<MSatisfaction.ISatisfactionDefaultParms>(
        `${this.communicationConfigService.getApiUri()}/apprenant/${id_apprenant}/session/${id_session}/satisfaction/default/value`
      );
    }
  }

  getSatisfactionOptionalValue(
    id_apprenant: number,
    id_session: number
  ): Observable<MSatisfaction.ISatisfactionOptinal[]> {
    if (this.configService.getOptions().useTestData === true) {
      const TEST_EMPTY_LIST = false;
      if (TEST_EMPTY_LIST) {
        return of([]);
      } else {
        return of(DATA_TEST.statisdactionOptionalValue);
      }
    } else {
      return this.http.get<MSatisfaction.ISatisfactionOptinal[]>(
        `${this.communicationConfigService.getApiUri()}/apprenant/${id_apprenant}/session/${id_session}/satisfaction/optional/value`
      );
    }
  }

  updateSatisfactionValue(
    id_apprenant: number,
    id_session: number,
    bodyRequest: MSatisfaction.ISatisfactionUpdate
  ): Observable<any> {
    if (this.configService.getOptions().useTestData === true) {
      return of('update');
    } else {
      return this.http.put<any>(
        `${this.communicationConfigService.getApiUri()}/apprenant/${id_apprenant}/session/${id_session}/satisfaction`,
        bodyRequest
      );
    }
  }
}
